import styled, { css } from "styled-components";

export const Paragraph = styled.div`
    margin: 0;
    ${(props) =>
        props.bolder &&
        css`
            font-weight: bolder;
        `}
`;

export const MainDialog = styled(Paragraph)`
    font-weight: bolder;
`;

export const CenteredMainDialog = styled(MainDialog)`
    text-align: center;
`;

export const NoteParagraph = styled.div`
    margin-top: 1rem;
    font-weight: bolder;
`;

export const TwoColumnRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: var(--gap-m);
`;

export const ConditionalColumnsRow = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    column-gap: var(--gap-m);
`;

export const ConditionalRowGap = styled.div`
    display: grid;
    row-gap: var(--gap-m);
`;
